var BooleanLiteral = {
  print: function print(_ref) {
    var node = _ref.node;
    return node.value ? 'true' : 'false';
  }
};
module.exports = BooleanLiteral;